import { gql } from "@apollo/client";

export const allProducts = gql`
  query {
    allProducts {
      success

      error

      message

      data {
        id

        productCode

        productName

        productCategory

        productBrandCode
        productImage

        productBrand

        productUom

        baseUom

        conversion

        vat

        bas

        cod

        csh

        smt

        vansl

        createdAt

        lastupdate
      }
    }
  }
`;

export const allSampleQuery = gql`
  query GetAllProductSamples($filter: ProductSampleFilterInput) {
    getAllProductSamples(filter: $filter) {
      success
      error
      message
      data {
        id
        sampleProvidedDate
        quantityProvided
        product {
          productName
        }
        customer {
          customerName
        }
      }
    }
  }
`;

export const allReceivedSample = gql`
  query GetReceivedProductSamples($filter: ProductSampleFilterInput) {
    getReceivedProductSamples(filter: $filter) {
      success
      error
      message
      data {
        id
        sampleProvidedDate
        quantityProvided
        product {
          productName
        }
        customer {
          customerName
        }
        createdAt
        createdBy {
          id
          employeeName
          firstName
          lastName
          username
        }
      }
    }
  }
`;

export const allYetToReceiveSample = gql`
  query GetPendingProductSamples($filter: ProductSampleFilterInput) {
    getPendingProductSamples(filter: $filter) {
      success
      error
      message
      data {
        id
        sampleProvidedDate
        quantityProvided
        product {
          productName
        }
        customer {
          customerName
        }
        createdAt
        createdBy {
          id
          employeeName
          firstName
          lastName
          username
        }
      }
    }
  }
`;

//Create Sample Mutation
export const createSampleMutation = gql`
  mutation CreateProductSample($input: CreateProductSampleInput!) {
    createProductSample(input: $input) {
      success
      error
      message
    }
  }
`;

//Edit Sample Mutation
export const updateSampleMutation = gql`
  mutation UpdateProductSample($input: UpdateProductSampleInput!) {
    updateProductSample(input: $input) {
      success
      error
      message
    }
  }
`;

//Get Sample Data By ID
export const getSampleDataById = gql`
  query GetProductSampleById($id: ID!) {
    getProductSampleById(id: $id) {
      success
      error
      message
      data {
        product {
          id
          productName
          productCode
        }
        customer {
          id
          customerName
          customerCode
        }
        sampleProvidedDate
        quantityProvided
      }
    }
  }
`;

//Create Feedback
export const createFeedbackMutation = gql`
  mutation CreateProductFeedback($input: CreateProductFeedbackInput!) {
    createProductFeedback(input: $input) {
      success
      error
      message
    }
  }
`;

//Get Feedback By ID
export const getFeedbackByID = gql`
  query GetFeedbackBySampleId($sampleId: ID!) {
    getFeedbackBySampleId(sampleId: $sampleId) {
      success
      error
      message
      data {
        id
        feedbackCollectedDate
        purchaseIntent
        productQualityRating
        packagingQualityRating
        valueForMoneyRating
        overallRating
        suggestedImprovements
        sample {
          id
        }
      }
    }
  }
`;

//Get All Customer
export const todayCustomers = gql`
  query {
    todayCustomers {
      id
      customerCode
      customerName
      createdAt
      lastUpdate
    }
  }
`;
